export function Exclamation(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.2083 8C20.8042 8 19.7 9.20006 19.8166 10.5993L21.4166 29.7993C21.5203 31.0432 22.5601 32 23.8083 32H24.1917C25.4399 32 26.4797 31.0432 26.5834 29.7993L28.1834 10.5993C28.3 9.20006 27.1958 8 25.7917 8H22.2083Z"
          fill="currentColor"
        />
        <path
          d="M24 34C22.3432 34 21 35.3431 21 37C21 38.6569 22.3432 40 24 40C25.6569 40 27 38.6569 27 37C27 35.3431 25.6569 34 24 34Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
